/*
 * VULCAN
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/permissionsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Permissions. */
var Permissions = /** @class */ (function () {
    /**
     * Create a Permissions.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Permissions(client) {
        this.client = client;
    }
    Permissions.prototype.getPermissions = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getPermissionsOperationSpec, callback);
    };
    Permissions.prototype.createPermission = function (request, options, callback) {
        return this.client.sendOperationRequest({
            request: request,
            options: options
        }, createPermissionOperationSpec, callback);
    };
    Permissions.prototype.getPermission = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, getPermissionOperationSpec, callback);
    };
    Permissions.prototype.updatePermission = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, updatePermissionOperationSpec, callback);
    };
    Permissions.prototype.deletePermission = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, deletePermissionOperationSpec, callback);
    };
    Permissions.prototype.getOrphanedPermissions = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getOrphanedPermissionsOperationSpec, callback);
    };
    return Permissions;
}());
export { Permissions };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/permissions",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PermissionResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createPermissionOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/permissions",
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdatePermissionRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.PermissionResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getPermissionOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/permissions/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: Mappers.PermissionResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updatePermissionOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/permissions/{id}",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdatePermissionRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.PermissionResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var deletePermissionOperationSpec = {
    httpMethod: "DELETE",
    path: "api/v10/permissions/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getOrphanedPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/permissions/orphaned",
    responses: {
        200: {
            bodyMapper: Mappers.OrphanedPermissionsResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=permissions.js.map